import { render, staticRenderFns } from "./Ppbdetail.vue?vue&type=template&id=69369a67"
import script from "./Ppbdetail.vue?vue&type=script&lang=js"
export * from "./Ppbdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports